import { Auth } from '@util/Auth';
import { MedicareAccessTrack } from 'hydra-data-types';
import { ApiClient } from '../../../api/ApiClient';
import { isExcludedFromMedicareAccess, isMedicareOriginal } from '../../../util/MedicareAccess';
import { store as baseStore } from '../../Store';
import { updateUserDataInDb } from './UpdateUserDataInDb';

/**
 * Kick off the Medicare Access eligibility check for the behavioural-health track. The backend reads
 * the user's just-saved MBI/patient details from Firestore, calls CMS, and writes the resulting
 * `lifecycleStatus` to `/users/<userId>/medicare_access/<track>` — which the coverage-loading screen
 * later reads. The call only returns `{ success: true }`; the outcome lives in that doc.
 *
 * Fire-and-forget from the MBI screen: the result is consumed much later (after the PROMs), so we
 * don't block the user here.
 */
export async function checkMedicareAccessEligibility(store = baseStore): Promise<void> {
  const state = store.getState();
  const { user } = state;
  // Only Original Medicare users in an ACCESS state (and not self-paying) may be checked with CMS.
  if (
    !Auth.isUserSignedIn() ||
    user.userId === undefined ||
    isExcludedFromMedicareAccess(state) ||
    !isMedicareOriginal(state)
  ) {
    return;
  }

  // The backend reads the patient details from Firestore, so make sure they're persisted first.
  await updateUserDataInDb(store);
  await new ApiClient().checkEligibility({ track: MedicareAccessTrack.BehaviouralHealth });
}
